import { defineComponent as _defineComponent } from 'vue'
import { useContext, useRoute } from '@nuxtjs/composition-api';
import { Resource } from '~/types/resource';
import Card from '~/components/card/Card.vue';

interface Props {
  resources: Resource[];
  title?: string;
  page: {
    name: string | null;
    id: number;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PinnedResources',
  props: {
    resources: null,
    title: null,
    page: null
  },
  setup(__props: any) {

const props = __props as {
  resources: Resource[];
  title?: string;
  page: {
    name: string | null;
    id: number;
  };
};



const { i18n, $config } = useContext();
const route = useRoute();

const sendPinnedResourceClickedEvent = (resource: Resource) => {
  const buttonParams = {
    Page_Country: i18n.locale,
    Page_Url: $config.baseURL + route.value.path,
    Page_Name: props.page.name ?? '',
    Page_ID: props.page.id,
    Resource_ID: resource.id,
    Resource_Name: resource.name,
  };
};

return { __sfc: true,props, i18n, $config, route, sendPinnedResourceClickedEvent, Card }
}

})